// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function LinkIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M17.192 23.295a1 1 0 0 1 0 1.414l-1.242 1.25a7.005 7.005 0 0 1-9.903-9.909l3.015-3.015a7 7 0 0 1 9.602-.285 1.002 1.002 0 1 1-1.33 1.5 5 5 0 0 0-6.857.204l-3.015 3.011a5.001 5.001 0 0 0 7.073 7.073l1.242-1.243a1 1 0 0 1 1.415 0Zm8.76-17.25a7.01 7.01 0 0 0-9.902 0l-1.243 1.244a1 1 0 1 0 1.415 1.414l1.243-1.243a5 5 0 1 1 7.073 7.073l-3.015 3.017a5 5 0 0 1-6.857.2 1.003 1.003 0 0 0-1.33 1.5 7 7 0 0 0 9.601-.282l3.015-3.015a7.01 7.01 0 0 0 0-9.905v-.003Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
